import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../ui/dialog';

interface ArchiveConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export default function ArchiveConfirmationModal({ open, onClose, onConfirm, isLoading }: ArchiveConfirmationModalProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}>
      <DialogContent data-testid="archive-confirmation-modal" className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-display text-[20px]">Archive Activity?</DialogTitle>
          <DialogDescription>
            This activity will be archived and cannot be returned to any other state.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-semibold rounded-pine-input border-[1.5px] border-pine-line text-pine-ink-soft hover:bg-pine-hover-button transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            data-testid="archive-confirm-button"
            onClick={onConfirm}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-semibold rounded-pine-input border-[1.5px] border-pine-danger text-pine-danger hover:bg-pine-danger hover:text-white transition-colors disabled:opacity-50"
          >
            {isLoading ? 'Archiving...' : 'Archive'}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
